import { arrayOf, number, shape } from 'prop-types';
import React, { PureComponent } from 'react';
import { Image, StyleSheet, View } from 'react-native';

import { C } from '../../common';
import { Consumer } from '../../context';
import { THEME } from '../../reactor/common';
import { Button, Dialog, Text } from '../../reactor/components';
import Uri from '../Uri';
import styles from './DialogSuggestion.style';

const { AMPLITUDE: { ON_CLICK, CLICK_TYPE } } = C;
const { COLOR } = THEME;
const intersection = (a = [], b = []) => a.filter(n => b.indexOf(n) !== -1).length > 0;

class DialogSuggestion extends PureComponent {
  state = {
    closed: false,
  }

  _onClose = (logEvent) => {
    logEvent(ON_CLICK, { type: CLICK_TYPE.SUGGESTION_CLOSE });
    this.setState({ closed: true });
  }

  render() {
    const {
      _onClose,
      props: {
        dataSource: {
          backgroundColor, color, pages = [], title, image, link,
        },
        visiblePages,
      },
      state: { closed },
    } = this;
    const visible = !closed && intersection(pages, visiblePages);
    const highlight = backgroundColor !== undefined;

    return (
      <Consumer>
        { ({ dataSource: { primary } = {}, logEvent }) => (
          <Dialog
            background={false}
            highlight={backgroundColor !== undefined}
            style={StyleSheet.flatten([styles.frame, backgroundColor && { backgroundColor }])}
            styleContainer={styles.container}
            visible={visible}
          >
            <View style={styles.row}>
              <Text subtitle level={2} color={highlight ? COLOR.WHITE : color} style={styles.title}>
                {title}
              </Text>
              <Button
                contained={false}
                color={highlight ? undefined : COLOR.TEXT}
                icon={highlight ? 'closeContrast' : 'close'}
                onPress={() => _onClose(logEvent)}
                rounded
                style={styles.buttonClose}
              />
            </View>
            <View style={[styles.row, styles.rowCentered]}>
              <Image resizeMode="contain" source={{ uri: image }} style={styles.image} />
              { link
                && (
                <Uri eventProps={{ target: link.uri }} target="_blank" to={link.uri}>
                  <Button responsive {...link} color={link.color || primary} />
                </Uri>
                )}
            </View>
          </Dialog>
        )}
      </Consumer>
    );
  }
}

DialogSuggestion.propTypes = {
  dataSource: shape({}).isRequired,
  visiblePages: arrayOf(number).isRequired,
};

export default DialogSuggestion;
